















import icoLookup from '@/utilities/ico-lookup'
import { includes } from 'lodash'
import { Vue, Component } from 'vue-property-decorator'
import * as db from '@shared/types/database'
import api from '@/api'
import S3Assets from '@/api/S3Assets'

interface UploadAsset {
  key: string
  mimetype: string
  filename: string
}

@Component
export default class ImagePicker extends Vue {
  file: File | null = null
  processing = false

  get imageTypeMap () {
    return icoLookup
  }

  initFileChooser () {
    (this.$refs.fileInput as HTMLInputElement).click()
  }

  async handleFileChange (event: Event) {
    event.preventDefault()
    const files = (event.target as HTMLInputElement).files
    if (!files) {
      throw new Error('No files')
    }
    const file = files[0]
    if (!this.file || file.name !== this.file.name) {
      var key = (Math.random().toString(36) + '00000000000000000').slice(2, 16) + '_' + file.name.replace(/[^A-Z0-9.]+/ig, '_')
      this.file = file
      await this.uploadFile(file, key)
      const asset = await this.formatAsset({
        key: key,
        mimetype: file.type,
        filename: file.name
      })
      this.$emit('addAsset', asset)
      this.file = null
      this.processing = false
    }
  }

  uploadFile (file: File, key: string): Promise<any> {
    return api.uploadFile(file, key)
  }

  async formatAsset (asset: UploadAsset): Promise<db.Prototype> {
    const url = await S3Assets.generateAssetUrl(asset.key)
    let assetType: db.AssetType = 'clientupload'

    if (includes(['image/jpeg', 'image/png', 'image/jpg'], asset.mimetype)) {
      assetType = ''
    }
    if (includes(['application/msword', 'application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'], asset.mimetype)) {
      assetType = 'document'
    }
    if (includes(['audio/mpeg', 'audio/x-m4a'], asset.mimetype)) {
      assetType = 'audio'
    }
    if (includes(['video/mp4'], asset.mimetype)) {
      assetType = 'video'
    }
    const formattedAsset: db.Prototype = {
      asset_type: assetType,
      title: asset.filename.replace(/\.[^/.]+$/, ''),
      url: url
    }
    return formattedAsset
  }
}
